import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { XAxis, CartesianGrid, Tooltip, ResponsiveContainer, YAxis, LineChart, Legend, Line } from "recharts";

const chartStyles = {
  width: "100%",

  padding: "10px",
  color: "gray",
  ".title": { marginBottom: "20px" },
  ".chartGrid": { stroke: "rgb(228, 225, 225)" },
  "& .areachartBox": {
    boxShadow: "0px 2px 4px 0px #45C0CB",
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: "url('/path/to/your/image.png')",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      opacity: 1,
      zIndex: 1,
      backgroundColor: "red",
      width: "100px",
      height: "20px",
    },
  },
};

function CustomTooltip({ active, payload, keywords }) {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        {payload.map((entry, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index}>
            <strong>{keywords[index]}</strong>: {entry.value}
          </div>
        ))}
      </div>
    );
  }

  return null;
}

function SelectKeywordChart({ checkedRows }) {
  const [chartData, setChartData] = useState([]);
  const [keywords, setKeywords] = useState([]);

  const anyChecked = checkedRows.some(row => row.checked);

  useEffect(() => {
    if (anyChecked) {
      const checkedRowsss = checkedRows.filter(row => row.checked);
      const dates = checkedRowsss.length > 0 ? checkedRowsss[0].dates : [];

      const formattedData = dates.map((date, index) => {
        const row = {
          name: new Date(date).toLocaleDateString("en-US", { month: "short", day: "numeric" }),
        };

        checkedRowsss.forEach((rowData, i) => {
          row[`row-${i + 1}`] = rowData.ranks[index];
        });

        return row;
      });

      setChartData(formattedData);
      setKeywords(checkedRowsss.map(row => row.keyword));
    }
  }, [checkedRows, anyChecked]);

  return (
    <Box sx={chartStyles}>
      {anyChecked ? (
        <ResponsiveContainer height={300}>
          <LineChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" className="chartGrid" />
            <XAxis dataKey="name" stroke="gray" />
            <YAxis interval="preserveStartEnd" domain={[0, 100]} />

            {/* Use the custom tooltip */}
            <Tooltip content={<CustomTooltip keywords={keywords} />} />

            <Legend />

            {/* Dynamically set the line names for each keyword */}
            {keywords.map((keyword, index) => (
              <Line
                key={keyword}
                type="monotone"
                dataKey={`row-${index + 1}`}
                stroke={`#${Math.floor(Math.random() * 16777215).toString(16)}`} // Random color for each line
                strokeWidth={2}
                activeDot={{ r: 8 }}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <Typography variant="h6" color="gray" align="center">
          No keyword selected
        </Typography>
      )}
    </Box>
  );
}

export default SelectKeywordChart;
